import { logger } from '@/lib/logging/core';

/** Browser-safe contextual interface backed by the shared logger. */
export const logDashboard = {
  info: (message: string, context?: Record<string, unknown>) =>
    logger.info({ component: 'Dashboard', ...context }, message),
  debug: (message: string, context?: Record<string, unknown>) =>
    logger.debug({ component: 'Dashboard', ...context }, message),
  warn: (message: string, context?: Record<string, unknown>) =>
    logger.warn({ component: 'Dashboard', ...context }, message),
  error: (
    message: string,
    error?: unknown,
    context?: Record<string, unknown>
  ) =>
    logger.error({ component: 'Dashboard', ...context, err: error }, message),
};
